import { createSelector } from 'reselect';
import { getCompanySettings } from './getCompanySettings';

export const getClockOutFlowEnabled = createSelector(
  [getCompanySettings],
  (companySettings) => {
    return companySettings?.clockOutFlowEnabled ?? true;
  }
);
